export default function CrocR() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 600 207">
      <path
        fill="#BFE4C8"
        fillRule="evenodd"
        d="M0 42.73v18.182l6.06 6.06 12.122 18.183V66.973h12.121l6.06 18.182 12.122-18.182h12.121l6.06 18.182 6.061-18.182H90.91l6.06 18.182 12.122-18.182h18.182l6.06 18.182 6.061-18.182h12.121v18.182l-30.303 6.06-6.06-12.121-12.122 18.182H90.91L78.787 85.155l-12.121 18.181H54.545l-6.06-18.181-18.182 30.303-18.182-18.182V139.7l230.303 6.061v30.303l-24.242 30.303h66.667l18.181-42.425h200v18.182l-24.242 24.243h72.727l6.061-24.243v-30.303l42.424-6.06V24.549h-6.061V12.427L551.515 30.61V6.367L503.03 30.609V6.367l-54.545 24.242V6.367l-42.424 24.242V.306l-42.425 24.242H242.424l-38.603 1.93c-3.849-8.297-12.254-14.051-22.003-14.051-10.606 0-19.621 6.81-22.91 16.297l-137.002 6.85a12.104 12.104 0 0 0-9.785-4.964c-4.452 0-8.343 2.4-10.45 5.976L0 36.67v6.06Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
